'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toastr = require('toastr');

var _toastr2 = _interopRequireDefault(_toastr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// defaults
_toastr2.default.options.positionClass = 'toast-bottom-right'; /**
                                                                *  Module replacement for abp.notify API.
                                                                */


function showNotification(type, message, title, options) {
    if (message || title) {
        _toastr2.default[type](message, title, options);
    }
}

function success(message, title, options) {
    showNotification('success', message, title, options);
}

function info(message, title, options) {
    showNotification('info', message, title, options);
}

function warn(message, title, options) {
    showNotification('warning', message, title, options);
}

function error(message, title, options) {
    showNotification('error', message, title, options);
}

exports.default = {
    success: success,
    info: info,
    warn: warn,
    error: error
};


//////////////////
// WEBPACK FOOTER
// ./~/linksoft/notify.js
// module id = 35
// module chunks = 0 1 2